import React from 'react';

export default function IconTick() {
  return (
    <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Agilytics-02" transform="translate(-922.000000, -26.000000)" fill="#FFFFFF" fillRule="nonzero">
          <g id="Group-5" transform="translate(869.000000, 23.000000)">
            <g id="Path-2" transform="translate(53.000000, 3.000000)">
              <path
                d="M0.737906064,11.2978875 C1.01752903,11.5776179 1.36705773,11.7 1.73406287,11.7 C2.101068,11.7 2.45059671,11.5601348 2.73021967,11.2978875 L6.01578947,7.9935713 L9.30135928,11.2804043 C9.58098224,11.5601348 9.93051094,11.6825168 10.2975161,11.6825168 C10.6645212,11.6825168 11.0140499,11.5426516 11.2936729,11.2804043 C11.8354424,10.7384265 11.8354424,9.84678565 11.2936729,9.30480787 L7.99062664,6.01797487 L11.2761964,2.73114187 C11.8179659,2.18916409 11.8179659,1.29752322 11.2761964,0.755545438 C10.734427,0.213567656 9.84312877,0.213567656 9.30135928,0.755545438 L6.01578947,4.04237844 L2.73021967,0.738062284 C2.18845018,0.196084502 1.29715199,0.196084502 0.755382499,0.738062284 C0.21361301,1.28004007 0.21361301,2.17168093 0.755382499,2.71365871 L4.0409523,6.01797487 L0.737906064,9.30480787 C0.196136575,9.8642688 0.196136575,10.7384265 0.737906064,11.2978875 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
